// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__34uc8","list":"PatternAutocomplete_list__2fs9m"};